export const product = {
  field: {
    filterHeight: 40,
    filterWidth: 288,
  },
  layout: {
    sidePanelWidth: 576,
    wideSidePanelWidth: 640,
  },
  shadow: {
    menu: 3,
    surface: 1,
  },
};
